<header class="flex header">
  <h2>
    {{ 'rollInfoModal.title' | translateWF: 'Roll Information' }}
  </h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>
<section class="content">
  <div class="form-box-row">
    <label>
      {{ 'rollInfoModal.rollID' | translateWF: 'Roll ID' }}
    </label>
    <input pInputText type="text" class="w-full" [value]="roll?.id ?? '-'" [disabled]="true" />
  </div>
  <div class="form-box-row">
    <label>
      {{ 'rollInfoModal.rollNumber' | translateWF: 'Roll Number' }}
    </label>
    <input pInputText type="text" class="w-full" [value]="roll?.number ?? '-'" [disabled]="true" />
  </div>
  <div class="form-box-row">
    <label>
      {{ 'rollInfoModal.rollStatus' | translateWF: 'Roll Status' }}
    </label>
    <input pInputText type="text" class="w-full" [value]="statusName() || '-'" [disabled]="true" />
  </div>
  <div class="form-box-row">
    <label>
      {{ 'rollInfoModal.rollKO' | translateWF: 'Roll KO' }}
    </label>
    <input pInputText type="text" class="w-full" [value]="roll?.knittingOrderNumber ?? '-'" [disabled]="true" />
  </div>
  <div class="form-box-row">
    <label>
      {{ 'rollInfoModal.rollGreigeCode' | translateWF: 'Roll Greige Code' }}
    </label>
    <input pInputText type="text" class="w-full" [value]="(greige ?? roll?.greige)?.greigeCode ?? '-'" [disabled]="true" />
  </div>
  <div class="form-box-row">
    <label>
      {{ 'rollInfoModal.rollAssetID' | translateWF: 'Roll Asset ID' }}
    </label>
    <input pInputText type="text" class="w-full" [value]="roll?.assetId ?? '-'" [disabled]="true" />
  </div>
  <div class="form-box-row">
    <label>
      {{ 'rollInfoModal.rollYarnLotID' | translateWF: 'Roll Yarn Lot ID' }}
    </label>
    <input pInputText type="text" class="w-full" [value]="roll?.yarnLotId || '-'" [disabled]="true" />
  </div>
  <div class="form-box-row">
    <label>
      {{ 'rollInfoModal.rollYarnPlan' | translateWF: 'Roll Yarn Plan. Weight' }}
    </label>
    <input pInputText type="text" class="w-full" [value]="roll?.plannedWeight ?? '-'" [disabled]="true" />
  </div>
  <div class="form-box-row">
    <label>
      {{ 'rollInfoModal.timeStamp' | translateWF: 'Time Stamp' }}
    </label>
    <p-datepicker [iconDisplay]="'input'" [showIcon]="true" [disabled]="true" [formControl]="timeStamp" />
  </div>
</section>
<footer>
  <p-button class="w-full" [label]="'Close' | translateWF: 'Close'" variant="outlined" (click)="onClose()" />
</footer>
